
import React from "react";
import { Outlet } from "react-router-dom";
import { TabBar } from 'antd-mobile'

import { RootView, TabBarView } from "./factory/ViewUtil";
import { T } from "./language/LanduagesManager";

import {
    useNavigate,
    useLocation
} from 'react-router-dom'

import { 
  HomepageIcon,
  MarketIcon,
  TradeIcon,
  AssetsIcon
} from "./icons";


const Bottom = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { pathname } = location
    const setRouteActive = (value) => {
        navigate(value)
    }
  
    const tabs = [
      {
        key: '/',
        title: <span style={{color : '#0E1C39'}}>{T('homepage')}</span>,
        icon: (active)=> {return <HomepageIcon active={active}/>}
      },
      {
        key: '/market',
        title: <span style={{color : '#0E1C39'}}>{T('market')}</span>,
        icon: (active)=> {return <MarketIcon active={active}/>}
      },
      {
        key: '/trade',
        title: <span style={{color : '#0E1C39'}}>{T('trade')}</span>,
        icon: (active)=> {return <TradeIcon active={active}/>}
      },
      {
        key: '/assets',
        title: <span style={{color : '#0E1C39'}}>{T('assets')}</span>,
        icon: (active)=> {return <AssetsIcon active={active}/>}
      },
    ]
  
    return (
      <TabBar className="fixed-tab-bar" safeArea  activeKey={pathname} onChange={value => setRouteActive(value)}>
        {tabs.map(item => (
          <TabBar.Item key={item.key} icon={item.icon} title={item.title}/>
        ))}
      </TabBar>
    )
  }

const Main = ()=> {
    return (
        <RootView>
            <Outlet/>
            <TabBarView><Bottom/></TabBarView>
        </RootView>
    )
}
export default React.memo(Main)